var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgBroom = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 20 20",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.083 9.166c0-1.369-.563-2.305-1.4-2.863L17.083 0h-1.666L12.98 5.685c-.3.024-.6.074-.897.148 0 0-1.212.351-2.399 1.68l7.402 1.85-.001-.098-.002-.099Zm.013 1.059L9.122 8.23c-.284.41-.55.891-.788 1.444l8.817 2.205a51.165 51.165 0 0 1-.055-1.655Zm-8.841 8.473C9.166 17.633 9.583 15 9.583 15c-.532 1.065-2.577 2.622-3.382 3.006C2.597 16.613 1.25 15 1.25 15s5.481-.017 6.666-4.166a5.26 5.26 0 0 1 .083-.259l.04-.115 9.164 2.291c.38 5.477 1.546 7.249 1.546 7.249-4.708 0-7.851-.495-10.494-1.302Z"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgBroom);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/broom.7c96ee811f922ddc0ebac6484d5df9f0.svg";